import {  
  SAVING_SMTP_EMAIL_REQUEST, SAVING_SMTP_EMAIL_SUCCEDDED, SAVING_SMTP_EMAIL_FAILED,
  FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST, FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED, FETCHING_SMTP_EMAIL_INTEGRATION_FAILED,
} from '../actionTypes.jsx';
import {activatingIntegrationSuccedded, deactivatingIntegrationSuccedded, fetchingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const SMTP_BASE_URL = `${apiUrl}/api/2.0/integrations/smtp`;

export function authenticateAccount(configuration){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    return axios({
      method: 'POST',
      url: SMTP_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}

function authenticatingAccount(){
  return {
    type: SAVING_SMTP_EMAIL_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: SAVING_SMTP_EMAIL_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: SAVING_SMTP_EMAIL_FAILED,
    payload: error
  }
}

/**
* Fetch smtp email integration
*/
export function fetchSmtpIntegration() {
  return function (dispatch) {
    dispatch(fetchingSmtpIntegration());

    return axios({
      method: 'GET',
      url: SMTP_BASE_URL
    })
    .then((response) => {
      dispatch(fetchingSmtpIntegrationSuccedded(response.data));
      dispatch(fetchingIntegrationSuccedded(response.data))
    })
    .catch(error =>
      dispatch(fetchingSmtpIntegrationFailed(error.errors))
    )
  }
}

function fetchingSmtpIntegration() {
  return {
    type: FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST,
    payload: {}
  }
}

function fetchingSmtpIntegrationSuccedded(json) {
  return {
    type: FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function fetchingSmtpIntegrationFailed(error) {
  return {
    type: FETCHING_SMTP_EMAIL_INTEGRATION_FAILED,
    payload: error
  }
}

